import React from 'react';
import SeverityLabel from '../../../../components/SeverityLabel/SeverityLabel';

const RFULegend = () => {
    return (
        <div className="text-center" style={{ lineHeight: '2em' }}>
            <span style={{ fontWeight: 'bold' }}>Abnormality status:</span>
            <SeverityLabel code="red" style={{ marginLeft: 25 }} /> No RA / all RA cancelled
            <SeverityLabel code="orange" style={{ marginLeft: 25 }} /> At least one RA
            <SeverityLabel code="yellow" style={{ marginLeft: 25 }} /> All RA executed
            <SeverityLabel code="green" style={{ marginLeft: 25 }} /> Abn. closed
            <SeverityLabel code="grey" style={{ marginLeft: 25 }} /> Abn. cancelled
            <SeverityLabel code="white" style={{ marginLeft: 25 }} /> No abn.
        </div>
    );
};

export default RFULegend;
